import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { fullImagePath } from '../utils/fullImagePath';

@Injectable({
  providedIn: 'root',
})
export class ImagePreloaderService {
  constructor() {}

  nullImage$ = new BehaviorSubject(true);

  preloadImage(fileName: string, force = false) {
    if (!fileName) return this.nullImage$;

    if (!this.loadedImages[fileName]) {
      this.loadedImages[fileName] = new BehaviorSubject<boolean>(false);
    } else {
      return this.loadedImages[fileName];
    }

    const image = new Image();
    image.src = fullImagePath(fileName);
    image.onload = (e: Event) => {
      try {
        image
          .decode()
          .then(() => {
            this.loadedImages[fileName].next(true);
          })
          .catch(() => {
            this.loadedImages[fileName].next(true);
          });
      } catch (ex) {
        // maybe image.decode isn't supported or throws an error
        this.loadedImages[fileName].next(true);
      }
    };
    image.onerror = () => {
      this.loadedImages[fileName].next(true);
    };
    return this.loadedImages[fileName];
  }

  private loadedImages: {
    [fileName: string]: BehaviorSubject<boolean>;
  } = {};

  hasLoaded(fileName: string) {
    if (!this.loadedImages[fileName]) {
      this.loadedImages[fileName] = new BehaviorSubject<boolean>(false);
    }
    return this.loadedImages[fileName].asObservable();
  }
}
